import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const VARIANTS = {
  primary: "btn-glow bg-[#2F6BFF] text-white hover:bg-[#4B82FF]",
  secondary: "border border-white/15 bg-white/[0.04] text-white hover:border-white/30 hover:bg-white/[0.08]",
};

const SIZES = {
  sm: "h-9 px-4 text-sm",
  md: "h-11 px-5 text-[15px]",
  lg: "h-12 px-6 text-[15px]",
};

export const CTAButton = ({
  to,
  href,
  variant = "primary",
  size = "md",
  arrow = true,
  type = "button",
  className,
  testId,
  children,
  ...rest
}) => {
  const cls = cn(
    "group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-medium transition-[background-color,border-color,box-shadow,color,opacity] duration-300 disabled:cursor-not-allowed disabled:opacity-60",
    SIZES[size],
    VARIANTS[variant],
    className,
  );
  const content = (
    <>
      {children}
      {arrow && (
        <ArrowRight aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
      )}
    </>
  );
  if (to)
    return (
      <Link to={to} className={cls} data-testid={testId} {...rest}>
        {content}
      </Link>
    );
  if (href)
    return (
      <a href={href} className={cls} data-testid={testId} {...rest}>
        {content}
      </a>
    );
  return (
    <button type={type} className={cls} data-testid={testId} {...rest}>
      {content}
    </button>
  );
};
